var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEthereum(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_566_8561)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5143 31.0473L9.51831 25.6787L20.5044 40.4624L22.1549 38.2412V30.2439L20.5143 31.0473Z",
    fill: "#708299"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5046 0.84082L7.88647 23.4819H33.123L20.5046 0.84082Z",
    fill: "#708299"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1228 23.5155L20.5044 0.84082V23.5155H33.1228Z",
    fill: "#68788E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6873 13.4155H19.1636V15.8919H16.6873V13.4155Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5044 17.3331L20.4548 17.3096L7.88745 23.5004H7.89864L20.466 29.6913L20.5155 29.6677L22.1548 28.8654V18.1415L20.5044 17.3331Z",
    fill: "#3C3C47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6873 8.73145H19.1636V11.2078H16.6873V8.73145Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5144 31.0471L20.5044 40.4621L31.4983 25.6685L20.5144 31.0471Z",
    fill: "#68788E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0995 23.5004L20.5047 17.3331L20.4551 17.3096L20.4663 29.6913L20.5158 29.6677L33.1107 23.5004H33.0995Z",
    fill: "#31313B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_566_8561"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.6215,
    height: 39.6215,
    fill: "white",
    transform: "translate(0.689453 0.84082)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereum);
export default __webpack_public_path__ + "static/media/Ethereum.729e11849c68e7b5533dbb30c025ebca.svg";
export { ForwardRef as ReactComponent };